/**
 * `/api/friends` and the user search behind the Añadir tab.
 *
 * Reads and writes only. Nothing here pushes into the store: every write the
 * server accepts comes back as a `SocialRoom` message to *both* parties, and
 * having the caller also mutate its own copy would mean two sources for one
 * list and a race between them. The panel refreshes from `list`/`requests`
 * after a write, which is one round trip and always right.
 */

import type { Friend, FriendRequest, FriendRequests, UserSearchResult } from '@ordago/shared';

import { api } from './rest';

export const friendsApi = {
  list: (signal?: AbortSignal) => api.get<{ friends: Friend[] }>('/friends', signal),

  requests: (signal?: AbortSignal) => api.get<FriendRequests>('/friends/requests', signal),

  request: (username: string) =>
    api.post<{ request: FriendRequest }>('/friends/requests', { username }),

  accept: (id: string) => api.post<void>(`/friends/requests/${encodeURIComponent(id)}/accept`),

  decline: (id: string) => api.post<void>(`/friends/requests/${encodeURIComponent(id)}/decline`),

  cancel: (id: string) => api.del<void>(`/friends/requests/${encodeURIComponent(id)}`),

  remove: (userId: string) => api.del<void>(`/friends/${encodeURIComponent(userId)}`),

  block: (userId: string) => api.post<void>(`/friends/${encodeURIComponent(userId)}/block`),

  unblock: (userId: string) => api.del<void>(`/friends/${encodeURIComponent(userId)}/block`),

  search: (q: string, signal?: AbortSignal) =>
    api.get<{ users: UserSearchResult[] }>(`/users/search?q=${encodeURIComponent(q)}`, signal),
};
